<template>
    <Multiselect
        v-model="model"
        :options="agencies"
        :multiple="false"
        :close-on-select="true"
        :class="{'is-invalid': !!error}"
        :label="'label'"
        :searchable="true"
        :filter-results="true"
        :strict="false"
        :submit="false"
        :native-support="true"
        :can-clear="canClear" />
    <span
        class="invalid-feedback"
        role="alert"
        v-if="error">
        {{ error }}
    </span>
</template>
<script setup lang="ts">
import Multiselect from "@vueform/multiselect";
import {useOriStore} from "@/stores/oriStore";
import {SelectItem, UploadType, Ori} from "@/types";
import {computed, onMounted, ref, toRef} from "vue";

const model = defineModel();
defineOptions({
    inheritAttrs: false,
});
const props = defineProps({
    error: {
        type: String,
        default: null,
    },
    selectFirst: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    excludedOris: {
        type: Array,
    },
    canClear:{
        type: Boolean,
        default: true,
    }
});
const oriStore = useOriStore();
const emit = defineEmits(["update:modelValue"]);

const agencies = computed(() => {
    let resultOris = oriStore.oris;

    if (props.excludedOris) {
        let excludedOris = props.excludedOris.filter((x) => x != model.value);

        if (excludedOris) {
            resultOris = resultOris.filter((item) => !excludedOris.includes(item.ori));
        }
    }

    let list = resultOris.map(
        (m) =>
            ({
                label: m.oriAgency,
                value: m.ori,
            } as SelectItem)
    );

    return list;
});

onMounted(async () => {
    if (oriStore.dataset != undefined || oriStore.oris?.length == 0) {
        oriStore.reset();
        await oriStore.fetchAll();
    }

    if (props.selectFirst) {
        emit("update:modelValue", oriStore.oris[0].ori);
    }
});
</script>
